<template>
  <div class="surface-content">
<!--    <a-button @click="readFile">ddddd</a-button>-->
    <v-nav/>
    <page-title :brain-type="$t('standardBrain')" :menu-name="$t('motorFunctionMapping')"
                style="position:absolute;top: 50px;left: 0px"/>
    <a-row :gutter="16" style="padding: 0 24px;margin-top: 50px" :style="{height : contentHeight}">
      <a-col :span="7">
        <div id="humanContainer" class="human-container"></div>
      </a-col>
      <a-col :span="11">
        <div id="brainContainer" class="brain-container"></div>
        <div class="positionContent" v-if="currentPoint != null"
             :style="{top : labelTop +'px', left : labelLeft + 'px'}">
          <a-tag color="purple" style="font-size: 16px">{{ currentPoint.px }}，{{ currentPoint.py }}，{{
              currentPoint.pz
            }}
          </a-tag>
        </div>
      </a-col>
    </a-row>
    <div class="condition-content">
      <div class="option-panel">
        <a-checkbox-group v-model:value="bodyId">
          <!--        <a-row>-->
          <!--          <a-col v-for="item in optionList" :key="item.value" :span="12">-->
          <!--            <a-checkbox :value="item.value">{{ item.label }}</a-checkbox>-->
          <!--          </a-col>-->
          <!--        </a-row>-->
          <a-row align="middle">
            <a-col :span="7">
              <img src="../../assets/icon/head.png" style="width: 60%"/>
            </a-col>
            <a-col :span="17">
              <a-row>
                <a-col v-for="item in headList" :key="item.value" :span="12">
                  <a-checkbox :value="item.value">
                    <div style="display: inline-block;height: 10px;width: 10px" :style="{backgroundColor: 'rgb('+ (item.color[0] * 255) +',' + (item.color[1]*255) + ',' + (item.color[2]*255) + ')'}"></div>
                    {{ item.label }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-divider style="border-color: white;margin: 12px 0" dashed/>
          <a-row align="middle">
            <a-col :span="7">
              <img src="../../assets/icon/hand.png" style="width: 60%"/>
            </a-col>
            <a-col :span="17">
              <a-row>
                <a-col v-for="item in handList" :key="item.value" :span="12">
                  <a-checkbox :value="item.value">
                    <div style="display: inline-block;height: 10px;width: 10px" :style="{backgroundColor: 'rgb('+ (item.color[0] * 255) +',' + (item.color[1]*255) + ',' + (item.color[2]*255) + ')'}"></div>
                    {{ item.label }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-divider style="border-color: white;margin: 12px 0" dashed/>
          <a-row align="middle">
            <a-col :span="7">
              <img src="../../assets/icon/body.png" style="width: 60%"/>
            </a-col>
            <a-col :span="17">
              <a-row>
                <a-col v-for="item in humanBodyList" :key="item.value" :span="12">
                  <a-checkbox :value="item.value">
                    <div style="display: inline-block;height: 10px;width: 10px" :style="{backgroundColor: 'rgb('+ (item.color[0] * 255) +',' + (item.color[1]*255) + ',' + (item.color[2]*255) + ')'}"></div>
                    {{ item.label }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-divider style="border-color: white;margin: 12px 0" dashed/>
          <a-row align="middle">
            <a-col :span="7">
              <img src="../../assets/icon/foot.png" style="width: 60%"/>
            </a-col>
            <a-col :span="17">
              <a-row>
                <a-col v-for="item in footList" :key="item.value" :span="12">
                  <a-checkbox :value="item.value">
                    <div style="display: inline-block;height: 10px;width: 10px" :style="{backgroundColor: 'rgb('+ (item.color[0] * 255) +',' + (item.color[1]*255) + ',' + (item.color[2]*255) + ')'}"></div>
                    {{ item.label }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
      <div class="option-panel" style="margin-top: 12px">
        <a-row align="middle">
          <a-col :span="7">
          </a-col>
          <a-col :span="17">
            <a-checkbox-group v-model:value="groupList" style="width: 100%">
              <a-row>
                <a-col :span="12">
                  <a-checkbox value="numb">numb</a-checkbox>
                </a-col>
                <a-col :span="12">
                  <a-checkbox value="move">move</a-checkbox>
                </a-col>
                <a-col :span="12">
                  <a-checkbox value="flex">flex</a-checkbox>
                </a-col>
                <a-col :span="12">
                  <a-checkbox value="extend">extend</a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </a-col>
        </a-row>
      </div>
      <div class="option-panel" style="margin-top: 12px">
        <div style="width: 100%;text-align: center">
          <a-button ghost style="color: white" @click="download">{{ $t("dataDownload") }}</a-button>
        </div>
      </div>
    </div>
  </div>
  <v-loading :show="loading"></v-loading>
</template>
<script>
import VNav from "@/components/public/VNav";
import vtkRenderWindowWithControlBar from "@kitware/vtk.js/Rendering/Misc/RenderWindowWithControlBar";
import util from "@/util/util";
import vtkOBJReader from "@kitware/vtk.js/IO/Misc/OBJReader";
import vtkMapper from "@kitware/vtk.js/Rendering/Core/Mapper";
import vtkActor from "@kitware/vtk.js/Rendering/Core/Actor";
import vtkDataArray from "@kitware/vtk.js/Common/Core/DataArray";
import vtkUtil from "@/util/vtkUtil";
import vtkPolyDataReader from '@kitware/vtk.js/IO/Legacy/PolyDataReader';
import vtkSphereSource from "@kitware/vtk.js/Filters/Sources/SphereSource";
import vtkCellPicker from "@kitware/vtk.js/Rendering/Core/CellPicker"
import vtkPointPicker from "@kitware/vtk.js/Rendering/Core/PointPicker"

import VLoading from "@/components/public/v-loading";
import PageTitle from "@/components/public/pageTitle";
import vtkMTLReader from '@kitware/vtk.js/IO/Misc/MTLReader';
import { Modal } from 'ant-design-vue';

export default {
  name: "standardBrain",
  components: {PageTitle, VLoading, VNav},
  data() {
    return {
      brainRenderWindow: {},
      brainRenderer: {},
      humanRenderWindow: {},
      humanRenderer: {},
      pointActorList: [],
      picker: {},
      humanActorList: [],
      lineActorList: [],
      pointPicker: {},
      labelHandle: null,
      preActor: null,

      currentPointActor: null,
      currentTextActor: null,
      groupList: [],
      bodyId: [],
      loading: false,
      pointList: [],

      dims: {},
      contentHeight: 0,

      labelTop: 50,
      labelLeft: 50,
    }
  },
  beforeMount() {
    this.computedHeight();
  },
  mounted() {
    this.initPage();
  },
  methods: {
    download() {
      // if (util.isNull(this.bodyId)) {
      //   util.error("请选择身体部位！");
      //   return;
      // }
      // var text = "";
      // this.pointList.map(item => {
      //   text += item.px + "," + item.py + "," + item.pz + "\n";
      // })
      // var filter = this.optionList.filter(item => this.bodyId.includes(item.value));
      // var name = []
      // filter.map(item => {
      //   name.push(item.label)
      // })
      // util.download_txt(name.join("-") + ".txt", text);
      // util.$post("/home/visitAddress", {type : "01"});
      Modal.info({
        title: this.$t('downloadTip', { email: 'baohongbo1990@hotmail.com' }),
      })

    },
    computedHeight() {
      this.contentHeight = (window.innerHeight - 48) + "px";
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    readFile() {
      util.$post("/home/readFile", {})
    },
    initPage() {
      // 初始化小人picker
      this.picker = vtkCellPicker.newInstance();
      this.picker.setPickFromList(1);
      this.picker.initializePickList();
      // 初始化小球picker
      this.pointPicker = vtkPointPicker.newInstance();
      this.pointPicker.setPickFromList(1);
      this.pointPicker.initializePickList();
      this.pointPicker.setTolerance(0.005)
      this.showMask();
      this.drawBrain();
      this.drawHuman();
      this.hideMask();
    },
    initHumanMouseClick() {
      this.humanRenderWindow.getInteractor().onLeftButtonPress((callData) => {
        if (this.humanRenderer !== callData.pokedRenderer) {
          return;
        }
        const pos = callData.position;
        const point = [pos.x, pos.y, 0.0];
        this.picker.pick(point, this.humanRenderer);
        if (this.picker.getActors().length > 0) {
          var actor = this.picker.getActors()[0];
          this.bodyId = [actor.getProperty().get().modalFlag];
          // if (!this.bodyId.includes(actor.getProperty().get().modalFlag)) {
          //   this.bodyId.push(actor.getProperty().get().modalFlag);
          // } else {
          //   this.bodyId = this.bodyId.filter(item => item !== actor.getProperty().get().modalFlag);
          // }
        } else {
          // this.bodyId = "";
        }
      })

      this.humanRenderWindow.getInteractor().onMouseMove((callData) => {
        if (this.humanRenderer !== callData.pokedRenderer) {
          return;
        }
        const pos = callData.position;
        const point = [pos.x, pos.y, 0.0];
        this.picker.pick(point, this.humanRenderer);
        if (this.picker.getActors().length > 0) {
          this.preActor = this.picker.getActors()[0];
        } else {
          this.preActor = null;
        }
      })
    },
    removeBrainAllPointAndLine() {
      this.pointActorList.map(item => {
        this.brainRenderer.removeActor(item);
      })
      this.lineActorList.map(item => {
        this.brainRenderer.removeActor(item);
      })
      this.pointActorList = [];
      this.brainRenderWindow.render();
    },
    drawBrainPoints() {
      vtkUtil.removePickerList(this.pointPicker, this.pointActorList);
      this.removeBrainAllPointAndLine();
      this.pointPicker.initializePickList();
      this.pointList.map(item => {
        var originalColor = this.colorMap[item.position];
        const sphere = vtkSphereSource.newInstance();
        sphere.setCenter(item.px, item.py, item.pz);
        sphere.setRadius(0.5);
        const sphereMapper = vtkMapper.newInstance();
        sphereMapper.setInputData(sphere.getOutputData());
        const sphereActor = vtkActor.newInstance();
        sphereActor.setMapper(sphereMapper);
        sphereActor.getProperty().setColor(originalColor);
        sphereActor.getProperty().set({cibrPoint: item, sphere: sphere, originalColor: originalColor}, true, true)
        this.pointPicker.addPickList(sphereActor);
        this.pointActorList.push(sphereActor);
        this.brainRenderer.addActor(sphereActor);
      });
      this.brainRenderWindow.render();
      this.initPointPickerEvent();
    },
    initPointPickerEvent() {
      this.currentPointActor = null;
      this.brainRenderWindow.getInteractor().onLeftButtonPress((callData) => {
        if (this.brainRenderer !== callData.pokedRenderer) {
          return;
        }
        console.log(callData)
        const pos = callData.position;
        const point = [pos.x, pos.y, 0.0];
        var brainContainer = document.getElementById("brainContainer");
        this.labelTop = brainContainer.getBoundingClientRect().bottom - pos.y * 0.7;
        this.labelLeft = brainContainer.getBoundingClientRect().left + pos.x * 0.7;
        this.pointPicker.pick(point, this.brainRenderer);
        if (this.pointPicker.getActors().length > 0) {
          var actor = this.pointPicker.getActors()[0];
          this.currentPointActor = actor;
        } else {
          this.currentPointActor = null;
        }
      })
    },
    drawHuman() {
      const fullScreenRenderer = vtkRenderWindowWithControlBar.newInstance();
      fullScreenRenderer.setControlSize(0);
      this.humanRenderer = fullScreenRenderer.getRenderer();
      this.humanRenderer.setBackground(0, 0, 0, 0)
      this.humanRenderWindow = fullScreenRenderer.getRenderWindow();
      fullScreenRenderer.setContainer(document.getElementById("humanContainer"))
      this.humanActorList = [];
      // this.readHumanObjMode("smallperson_body.obj", "index")
      // this.readHumanObjMode("smallperson_r_hand.obj", "middle")
      // this.readHumanObjMode("smallperson_l_hand.obj", "ring")
      this.bodyList.map(item => {
        this.readHumanObjMode(item.label, item.value, item.color)
      })
      this.initHumanMouseClick();
    },
    readHumanObjMode(fileName, flag, color) {
      const reader = vtkOBJReader.newInstance();
      // const reader = vtkOBJReader.newInstance({ splitMode: 'usemtl' });
      const materialsReader = vtkMTLReader.newInstance();
      materialsReader.setUrl(util.baseUrl + fileName + ".mtl").then(() => {
        reader.setUrl(util.baseUrl + fileName + ".obj").then(() => {
          const size = reader.getNumberOfOutputPorts();
          for (let i = 0; i < size; i++) {
            const polydata = reader.getOutputData(i);
            const name = polydata.get('name').name;
            const mapper = vtkMapper.newInstance();
            const actor = vtkActor.newInstance();
            materialsReader.applyMaterialToActor(name, actor);
            actor.setMapper(mapper);
            actor.rotateY(45)
            // actor.getProperty().setOpacity(0.2)
            actor.getProperty().set({modalFlag: flag, oldColor: color}, true, true)
            if (!util.isNull(color)) {
              actor.getProperty().setColor(color)
            } else {
              actor.getProperty().setColor(color)
            }
            this.picker.addPickList(actor);
            mapper.setInputData(polydata);
            this.humanRenderer.addActor(actor);
          }
          this.humanRenderer.resetCamera();
          this.humanRenderWindow.render();
        });
      })
    },
    drawBrain() {
      const fullScreenRenderer = vtkRenderWindowWithControlBar.newInstance();
      fullScreenRenderer.setControlSize(0)
      // fullScreenRenderer.setBackground([0.2627451, 0.20392157, 0.32156863]);
      this.brainRenderer = fullScreenRenderer.getRenderer();
      this.brainRenderer.setBackground(0, 0, 0, 0)
      this.brainRenderWindow = fullScreenRenderer.getRenderWindow();
      fullScreenRenderer.setContainer(document.getElementById("brainContainer"))
      // this.readObjMode(util.baseUrl + "BrainMesh_Ch2.obj", this.brainRenderer, this.brainRenderWindow);
      this.readObjMode(util.baseUrl + "surface_2f.obj", this.brainRenderer, this.brainRenderWindow);
    },
    drawBrianLines(renderer, renderWindow) {
      this.lineActorList = [];
      var lineActor1 = vtkUtil.getLineSourceActor(vtkUtil.pointList[0], vtkUtil.pointList[1], [1, 0, 0], 0.1);
      var lineActor2 = vtkUtil.getLineSourceActor(vtkUtil.pointList[1], vtkUtil.pointList[2], [0, 1, 0], 0.3);
      var lineActor3 = vtkUtil.getLineSourceActor(vtkUtil.pointList[2], vtkUtil.pointList[3], [0, 0, 1], 0.6);
      var lineActor4 = vtkUtil.getLineSourceActor(vtkUtil.pointList[3], vtkUtil.pointList[4], [0, 0, 0], 0.9);
      var lineActor5 = vtkUtil.getLineSourceActor(vtkUtil.pointList[4], vtkUtil.pointList[5], [1, 1, 1], 1);
      renderer.addActor(lineActor1);
      renderer.addActor(lineActor2);
      renderer.addActor(lineActor3);
      renderer.addActor(lineActor4);
      renderer.addActor(lineActor5);
      this.lineActorList.push(lineActor1)
      this.lineActorList.push(lineActor2)
      this.lineActorList.push(lineActor3)
      this.lineActorList.push(lineActor4)
      this.lineActorList.push(lineActor5)
      // renderer.resetCamera();
      renderWindow.render();
    },
    readObjMode(url, renderer, renderWindow) {
      const reader = vtkOBJReader.newInstance();
      reader.setUrl(url).then(() => {
        const size = reader.getNumberOfOutputPorts();
        for (let i = 0; i < size; i++) {
          const polydata = reader.getOutputData(i);
          const mapper = vtkMapper.newInstance();
          const actor = vtkActor.newInstance();
          actor.setMapper(mapper);
          actor.getProperty().setOpacity(0.1)
          mapper.setInputData(polydata);
          renderer.addActor(actor);
        }
        renderer.resetCamera();
        renderWindow.render();
      });
    },
    readVtkFile(url, renderer, renderWindow) {
      const reader = vtkPolyDataReader.newInstance();
      reader.setUrl(url).then(() => {
        const polydata = reader.getOutputData(0);
        let list = reader.toJSON().parseData.split("LOOKUP_TABLE default");
        let listElement = list[list.length - 1];
        let split = listElement.trim().split(/\s+/);
        let max = 1;
        let min = 0;
        var values = new Float32Array(split);
        const colors = vtkDataArray.newInstance({name: 'points', values});
        polydata.getPointData().setScalars(colors);
        const mapper = vtkMapper.newInstance({});
        var colorTransferFunction = vtkUtil.getColorTransferFunction();
        mapper.setLookupTable(colorTransferFunction);
        mapper.setScalarRange([min, max])

        const actor = vtkActor.newInstance();
        actor.setMapper(mapper);
        mapper.setInputData(polydata);
        renderer.addActor(actor);
        renderer.resetCamera();
        renderWindow.render();
      });
    },
    initBrainPoint() {
      if (util.isNull(this.bodyId)) {
        return;
      }
      var post = {
        groupList: JSON.stringify([]),
        bodyId: JSON.stringify(this.bodyId)
      }
      util.$post("/home/getPointList", post, (res) => {
        this.pointList = res.pointList;
        this.drawBrainPoints();
      }, this.showMask, this.hideMask);
    },
    reActiveHuman(newBodyId, oldBodyId) {
      var newIds = newBodyId.filter(item => !oldBodyId.includes(item));
      var newActors = this.humanRenderer.getActors().filter(item => newIds.includes(item.getProperty().get().modalFlag));

      var oldIds = oldBodyId.filter(item => !newBodyId.includes(item));
      var oldActors = this.humanRenderer.getActors().filter(item => oldIds.includes(item.getProperty().get().modalFlag));

      if (!util.isNull(oldActors)) {
        oldActors.map(item => {
          item.getProperty().setOpacity(1)
        })
      }
      if (!util.isNull(newActors)) {
        newActors.map(item => {
          item.getProperty().setOpacity(0.3)
        })
      }
      this.removeBrainAllPointAndLine();
      this.humanRenderWindow.render();
    },
    changePointColor() {
      this.pointActorList.map(item => {
        var pointType = item.getProperty().get().cibrPoint.pointtype;
        var color = item.getProperty().get().originalColor
        if (this.groupList.includes(pointType)) {
          if (pointType === "flex") {
            color = [0.5294, 0.7843, 0.5882];
          } else if (pointType === "numb") {
            color = [0.1569, 0.7372, 0.9098];
          } else if (pointType === "extend") {
            color = [0.9725, 0.7961, 0.8];
          } else if (pointType === "move") {
            color = [0.6509, 0.5098, 0.7255];
          }
        }
        item.getProperty().setColor(color)
        item.getProperty().set({oldColor: color}, true, true);
      })
      this.brainRenderWindow.render()
    },
    // drawNewText(newVal) {
    // var point = newVal.getProperty().get().cibrPoint;
    // var sphere = newVal.getProperty().get().sphere;
    // console.log(point)
    // if (util.isNull(point)) {
    //   return;
    // }
    // console.log(1)
    // if (!util.isNull(this.currentTextActor)) {
    //   this.brainRenderer.removeActor(this.currentTextActor);
    // }

    // this.currentTextActor = null;
    // this.currentTextActor = vtkActor.newInstance();
    // const psMapper = vtkPixelSpaceCallbackMapper.newInstance();
    // psMapper.setInputConnection(sphere.getOutputPort());
    // var textCtx = document.getElementsByTagName("canvas")[1].getContext('2d');
    // var dims = document.getElementById("brainContainer").getBoundingClientRect();
    // console.log(textCtx, dims)
    // psMapper.setCallback((coordsList) => {
    //   if (textCtx && dims) {
    //     textCtx.clearRect(0, 0, dims.width, dims.height);
    //     console.log(111111)
    //     coordsList.forEach((xy, idx) => {
    //       textCtx.font = '12px serif';
    //       textCtx.textAlign = 'center';
    //       textCtx.textBaseline = 'middle';
    //       textCtx.fillText(`p ${idx}`, xy[0], dims.height - xy[1]);
    //     });
    //   }
    // });
    // this.currentTextActor.setMapper(psMapper);
    // this.brainRenderer.addActor(this.currentTextActor);
    // this.brainRenderWindow.render()
    // }
  },
  watch: {
    preActor(newVal, oldVal) {
      if (!util.isNull(newVal)) {
        newVal.getProperty().setColor([0, 1, 0]);
        this.humanRenderWindow.render()
      }
      if (!util.isNull(oldVal)) {
        oldVal.getProperty().setColor(oldVal.getProperty().get().oldColor);
        this.humanRenderWindow.render()
      }
    },
    currentPointActor(newVal, oldVal) {
      if (!util.isNull(oldVal)) {
        var color = oldVal.getProperty().get().originalColor;
        if (!util.isNull(oldVal.getProperty().get().oldColor)) {
          color = oldVal.getProperty().get().oldColor;
        }
        oldVal.getProperty().setColor(color);
        this.brainRenderer.removeActor(this.currentTextActor);
        this.currentTextActor = null;
      }
      if (!util.isNull(newVal)) {
        newVal.getProperty().setColor([0, 1, 0]);
      }
      this.brainRenderWindow.render();
    },
    groupList() {
      // this.removeBrainAllPointAndLine();
      // this.initBrainPoint();
      this.changePointColor();
    },
    newList: {
      handler(newVal, oldVal) {
        this.reActiveHuman(newVal, oldVal);
        this.initBrainPoint();
      },
      deep: true
    }
  },
  computed: {
    newList() {
      return JSON.parse(JSON.stringify(this.bodyId))
    },
    currentPoint() {
      if (util.isNull(this.currentPointActor)) {
        return null
      }
      return this.currentPointActor.getProperty().get().cibrPoint;
    },
    headList() {
      var list = [];
      list.push({color: [1, 0.003921, 0], label: this.$t("eye"), value: "eye"});
      list.push({color: [1, 0.160784, 0.023529], label: this.$t("mouth"), value: "mouth"});
      list.push({color: [1, 0.333333, 0.007843], label: this.$t("tongue"), value: "tongue"});
      list.push({color: [1, 0.501960, 0.003921], label: this.$t("teeth"), value: "teeth"});
      list.push({color: [1, 0.666667, 0.003921], label: this.$t("throat"), value: "throat"});
      list.push({color: [1, 0.835294, 0], label: this.$t("face"), value: "face"});
      return list;
    },
    handList() {
      var list = [];
      list.push({color: [0.831372, 1, 0.003921], label: this.$t("thumbFinger"), value: "thumb"});
      list.push({color: [0.666667, 1, 0.007843], label: this.$t("indexFinger"), value: "index"});
      list.push({color: [0.501960, 1, 0], label: this.$t("middleFinger"), value: "middle"});
      list.push({color: [0.333333, 1, 0], label: this.$t("ringFinger"), value: "ring"});
      list.push({color: [0.172549, 1, 0], label: this.$t("pinky"), value: "pinky"});
      list.push({color: [0.007843, 1, 0], label: this.$t("wrist"), value: "wrist"});
      list.push({color: [0, 1, 0.149019], label: this.$t("palm"), value: "palm"});
      return list;
    },
    humanBodyList() {
      var list = [];
      list.push({color: [0, 1, 1], label: this.$t("torso"), value: "torso"});
      list.push({color: [0.003921, 0.835294, 1], label: this.$t("shoulder"), value: "shoulder"});
      list.push({color: [0.003921, 0.666667, 1], label: this.$t("waist"), value: "waist"});
      list.push({color: [0.007843, 0.501960, 1], label: this.$t("abdomen"), value: "abdomen"});
      list.push({color: [0, 0.333333, 1], label: this.$t("forearm"), value: "forearm"});
      return list;
    },
    footList() {
      var list = [];
      list.push({color: [0.498039, 0.003921, 1], label: this.$t("knee"), value: "knee"});
      list.push({color: [0.835294, 0, 1], label: this.$t("calf"), value: "calf"});
      list.push({color: [1, 0, 0.835294], label: this.$t("foot"), value: "foot"});
      return list;
    },
    colorMap(){
      var colorMap = {};
      this.headList.map(item => colorMap[item.value] = item.color);
      this.handList.map(item => colorMap[item.value] = item.color);
      this.humanBodyList.map(item => colorMap[item.value] = item.color);
      this.footList.map(item => colorMap[item.value] = item.color);
      return colorMap;
    },
    optionList() {
      var list = new Array();
      list.push({label: this.$t("thumbFinger"), value: "thumb"});
      list.push({label: this.$t("indexFinger"), value: "index"});
      list.push({label: this.$t("middleFinger"), value: "middle"});
      list.push({label: this.$t("ringFinger"), value: "ring"});
      list.push({label: this.$t("pinky"), value: "pinky"});
      list.push({label: this.$t("wrist"), value: "wrist"});
      list.push({label: this.$t("mouth"), value: "mouth"});
      list.push({label: this.$t("throat"), value: "throat"});
      list.push({label: this.$t("tongue"), value: "tongue"});
      list.push({label: this.$t("teeth"), value: "teeth"});
      list.push({label: this.$t("face"), value: "face"});
      list.push({label: this.$t("palm"), value: "palm"});
      list.push({label: this.$t("palm"), value: "palm"});
      list.push({label: this.$t("forearm"), value: "forearm"});
      list.push({label: this.$t("eye"), value: "eye"});
      list.push({label: this.$t("foot"), value: "foot"});
      list.push({label: this.$t("knee"), value: "knee"});
      list.push({label: this.$t("calf"), value: "calf"});
      list.push({label: this.$t("abdomen"), value: "abdomen"});
      list.push({label: this.$t("shoulder"), value: "shoulder"});
      list.push({label: this.$t("torso"), value: "torso"});
      list.push({label: this.$t("waist"), value: "waist"});
      return list;
    },
    bodyList() {
      var list = new Array();
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "拇指R", value: "thumb"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "拇指L", value: "thumb"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "食指R", value: "index"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "食指L", value: "index"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "中指R", value: "middle"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "中指L", value: "middle"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "环指R", value: "ring"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "环指L", value: "ring"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "小指R", value: "pinky"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "小指L", value: "pinky"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "手腕R", value: "wrist"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "手腕L", value: "wrist"});
      list.push({color: [0.63921569, 0.45098039, 0.39215686], label: "嘴", value: "mouth"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "喉咙", value: "throat"});
      list.push({color: [0.65098039, 0.41176471, 0.3372549], label: "舌头", value: "tongue"});
      list.push({color: [0.98039216, 0.98039216, 0.98039216], label: "牙齿", value: "teeth"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "面部R", value: "face"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "面部L", value: "face"});
      list.push({color: [0.40784314, 0.36470588, 0.36862745], label: "眉", value: "face"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "头部", value: "face"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "手掌L", value: "palm"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "手掌R", value: "palm"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "手R", value: "palm"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "手L", value: "palm"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "小臂L", value: "forearm"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "小臂R", value: "forearm"});
      list.push({color: [0.98039216, 0.98039216, 0.98039216], label: "眼球R", value: "eye"});
      list.push({color: [0.98039216, 0.98039216, 0.98039216], label: "眼球L", value: "eye"});
      list.push({color: [0.19607843, 0.19607843, 0.19607843], label: "瞳孔L", value: "eye"});
      list.push({color: [0.19607843, 0.19607843, 0.19607843], label: "瞳孔R", value: "eye"});
      list.push({color: [0.40784314, 0.36470588, 0.36862745], label: "瞳仁L", value: "eye"});
      list.push({color: [0.40784314, 0.36470588, 0.36862745], label: "瞳仁R", value: "eye"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "眼眶R", value: "eye"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "眼眶L", value: "eye"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "足R", value: "foot"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "足L", value: "foot"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "膝盖R", value: "knee"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "膝盖L", value: "knee"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "小腿R", value: "calf"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "小腿L", value: "calf"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "腹部", value: "abdomen"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "肩膀L", value: "shoulder"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "肩膀R", value: "shoulder"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "躯干", value: "torso"});
      list.push({color: [0.87058824, 0.7254902, 0.62745098], label: "腰部", value: "waist"});
      list.push({color: [0.63137255, 0.54901961, 0.45098039], label: "裤子", value: "kz"});
      // list.push({color : [0.87058824, 0.7254902, 0.62745098], label: "untitled", value: ""});
      return list;
    }
  }
}
</script>

<style scoped>

.surface-content {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  /*background-color: #433452;*/
}

.condition-content {
  width: 370px;
  /*background-color: #5A2781;*/
  /*border-radius: 12px;*/
  /*border: 1px #552D6D solid;*/
  /*padding: 16px 16px;*/
  position: absolute;
  margin: 50px 50px;
  top: 40px;
  right: 0;
}

.human-container {
  display: inline-block;
  width: 100%;
  height: 80vh;
}

.brain-container {
  width: 100%;
  height: 100%;
  display: inline-block;
}

.positionContent {
  position: fixed;
  top: 50px;
  left: 50px;
  z-index: 9;
  color: white;
  font-size: 24px;
}

/* 凸起效果样式 */
.brain-up {
  border-left: 1px solid #33B8EC;
  border-top: 1px solid #33B8EC;
  border-right: 3px solid #000;
  border-bottom: 3px solid #000;
}

</style>